export const stateObj = {
  user_name: null,
  user_id: null,
};
